import React, { Component } from "react";
import Logo from "../design/img/logo-white.png";
import Auth from "j-toker";

import LocalizedStrings from "react-localization";
import en from "../localization/localization-en.json";
import { renderErrorMessage } from "../helper/user_helper";

let strings = new LocalizedStrings({ en });
class UpdatePasswordView extends Component {
  state = {
    password: "",
    password_confirmation: "",
    errors: "",
    success: false
  };
  render() {
    return (
      <React.Fragment>
        <nav className="navbar tabbar center presentation_tab_bar pb-2">
          <img src={Logo} alt="Yaystack Logo" />
        </nav>
        {this.state.success ? (
          <div className="presentation center max_width_300">
            <label className="alert alert-success block mb-3 mt-3">
              Your password is now updated
            </label>
            <button
              className="btn btn_primary btn_yaystack mb-3 width_100"
              onClick={() => {
                this.props.history.push("/");
              }}
            >
              Enter
            </button>
          </div>
        ) : (
          <div className="presentation center max_width_300">
            <form onSubmit={this.handleUpdatePassword}>
              <label className="yaystack_input_text_label pt-5">
                <input
                  className="yaystack_input_text mb-3"
                  type="password"
                  required={false}
                  minLength="8"
                  value={this.state.password}
                  placeholder={strings.new_password}
                  onChange={this.handleChangePassword}
                />
              </label>
              <br />
              <label className="yaystack_input_text_label">
                <input
                  className="yaystack_input_text mb-3"
                  type="password"
                  required={false}
                  minLength="8"
                  value={this.state.password_confirmation}
                  placeholder={strings.new_password_confirmation}
                  onChange={this.handleChangePasswordConfirmation}
                />
              </label>
              <br />

              <input
                type="submit"
                value={strings.update}
                className="btn btn_primary btn_yaystack mb-3 width_100"
              />

              <label />
            </form>
            <div className="width_100 max_width_300">
              {renderErrorMessage(this.state.errors)}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleChangePasswordConfirmation = event => {
    this.setState({ password_confirmation: event.target.value });
  };

  handleUpdatePassword = event => {
    event.preventDefault();
    let errors = "";
    this.setState({ errors });
    Auth.updatePassword({
      password: this.state.password,
      password_confirmation: this.state.password_confirmation
    })
      .then(
        function(answer) {
          this.setState({ success: true });
        }.bind(this)
      )
      .fail(
        function(res) {
          let errors = res.reason + ": ";
          errors += res.data.errors.join(", ");
          this.setState({ errors });
        }.bind(this)
      );
  };
}

export default UpdatePasswordView;



// WEBPACK FOOTER //
// ./src/pages/update_password.jsx